"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledOverlay = _styledComponents.default.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: ${_constants.colours.font};
	z-index: 999;

	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 0.3;
		}
	}

	${({
  state
}) => state === 'opening' && `
    animation: fadeIn .2s forwards;
  `}

	${({
  state
}) => state === 'closing' && `
    animation: fadeIn .2s reverse forwards;
  `}

	${({
  state
}) => state === 'open' && `
    opacity: 0.3;
  `}
`;

const DrawerOverlay = ({
  state
}) => /*#__PURE__*/_react.default.createElement(StyledOverlay, {
  state: state
});

DrawerOverlay.propTypes = {
  state: _propTypes.string.isRequired
};
var _default = DrawerOverlay;
exports.default = _default;